( function( $, document, window ) {
	'use strict';

	$( function() {
		$('.js-case-studies-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navParent = $('.js-case-studies-carousel-nav', sliderContainer);

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 16,
				slidesPerView: 1.05,

				pagination: {
					el: $('.js-carousel-nav-pagination', sliderContainer)[0],
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="carousel-nav__bullet ' + className + '">' + (index + 1) + '</span>';
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', sliderContainer)[0],
					prevEl: $('.js-carousel-nav-prev', sliderContainer)[0],
				},

				breakpoints: {
					744: {
						slidesPerView: 2,
					},
				},
			});
		});
	} );
} )( jQuery, document, window );
